<template>
    <div class="layout-main-content">
        <page-title>
            <span>个人中心</span>
        </page-title>
        <div class="content scrollbar ivu-card">
            <div class="center-content">
                <page-title>
                    <span>个人信息</span>
                </page-title>
                <div class="form-content clearfix">
                    <img v-if="this.formItem.img" :src="this.formItem.img" />
                    <img
                        v-if="!this.formItem.img"
                        src="../../assets/default-person.png"
                    />
                    <div class="form">
                        <Form
                            :model="formItem"
                            :label-width="80"
                            label-position="left"
                        >
                            <FormItem label="用户名">
                                <Input
                                    v-model="formItem.loginName"
                                    disabled
                                ></Input>
                            </FormItem>
                            <FormItem label="角色">
                                <Input
                                    v-model="formItem.roleName"
                                    disabled
                                ></Input>
                            </FormItem>
                            <FormItem label="中文名称" v-if="formItem.cnName">
                                <Input
                                    v-model="formItem.cnName"
                                    disabled
                                ></Input>
                            </FormItem>
                            <FormItem label="性别" v-if="formItem.sex">
                                <Input :value="formItem.sex === '0' ? '男' : '女'" disabled></Input>
                            </FormItem>
                        </Form>
                    </div>
                </div>
                <Divider dashed
                ><span style="cursor: pointer" @click="showPasswordClick"
                >修改密码
                    <span class="icon-up" :class="{ down: showPassword }"
                    ><Icon type="ios-arrow-down" /></span></span
                ></Divider>
                <div v-show="showPassword">
                    <page-title>
                        <span>修改密码</span>
                    </page-title>
                    <div class="form-content">
                        <img style="visibility: hidden" src="" alt="" />
                        <div class="form">
                            <Form
                                :model="passwordForm"
                                :label-width="80"
                                :rules="rules"
                                ref="formValidate"
                                label-position="left"
                            >
                                <FormItem label="原密码" prop="oldPwd">
                                    <Input
                                        v-model="passwordForm.oldPwd"
                                        type="password"
                                        placeholder="请输入原密码"
                                    ></Input>
                                    <Tooltip
                                        class="form-tooltip theme-color"
                                        content="7-21位字母或数字"
                                        placement="top"
                                    >
                                        <Icon type="md-information-circle" />
                                    </Tooltip>
                                </FormItem>
                                <FormItem label="新密码" prop="newPwd">
                                    <Input
                                        v-model="passwordForm.newPwd"
                                        type="password"
                                        placeholder="请输入新密码"
                                    ></Input>
                                    <Tooltip
                                        class="form-tooltip theme-color"
                                        content="新密码不能和原密码相同"
                                        placement="top"
                                    >
                                        <Icon type="md-information-circle" />
                                    </Tooltip>
                                </FormItem>
                                <FormItem label="确认密码" prop="confirmPwd">
                                    <Input
                                        v-model="passwordForm.confirmPwd"
                                        placeholder="请输入确认密码"
                                        type="password"
                                    ></Input>
                                    <Tooltip
                                        class="form-tooltip theme-color"
                                        content="确认密码必须和新密码保持一致"
                                        placement="top"
                                    >
                                        <Icon type="md-information-circle" />
                                    </Tooltip>
                                </FormItem>
                                <FormItem class="btn-wrap">
                                    <Button @click="handlePwdCancel"
                                    >取消</Button
                                    >
                                    <Button
                                        type="primary"
                                        @click="handlePwdSubmit"
                                        style="margin-left: 8px"
                                    >确定</Button
                                    >
                                </FormItem>
                            </Form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '../../common/api'

export default {
    data() {
        const validatePass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入新密码'))
            } else {
                if (this.passwordForm.confirmPwd !== '') {
                    // 对第二个密码框单独验证
                    this.$refs.formValidate.validateField('confirmPwd')
                }
                callback()
            }
        }
        const validatePassCheck = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入确认密码'))
            } else if (value !== this.passwordForm.newPwd) {
                callback(new Error('确认密码和新密码不一致'))
            } else {
                callback()
            }
        }
        return {
            formItem: {
                loginName: '',
                roleName: '',
                cnName: '',
                sex: ''
            },
            passwordForm: {
                oldPwd: null,
                newPwd: null,
                confirmPwd: null
            },
            showPassword: false,
            rules: {
                oldPwd: [
                    {
                        required: true,
                        message: '请输入原密码',
                        trigger: 'blur'
                    }
                ],
                newPwd: [
                    {
                        required: true,
                        message: '请输入新密码',
                        trigger: 'blur'
                    },
                    { validator: validatePass, trigger: 'blur' }
                ],
                confirmPwd: [
                    {
                        required: true,
                        message: '请输入确认密码',
                        trigger: 'blur'
                    },
                    { validator: validatePassCheck, trigger: 'blur' }
                ]
            }
        }
    },
    created() {
        this.getCurrentInfo()
    },
    methods: {
        getCurrentInfo() {
            api.getCurrentInfo().then((res) => {
                if (res.resultCode === 0) {
                    console.log(res.data.userInfo[0].cnName)
                    this.formItem = {
                        loginName: res.data.loginName,
                        roleName: res.data.roleName,
                        cnName: res.data.userInfo && res.data.userInfo.length > 0 ? res.data.userInfo[0].cnName : '',
                        sex: res.data.userInfo && res.data.userInfo.length > 0 ? res.data.userInfo[0].sex : '',
                        img: res.data.userInfo && res.data.userInfo.length > 0 && res.data.userInfo[0].staffPhoto ? res.data.userInfo[0].staffPhoto : ''
                    }
                }
            })
        },
        handlePwdSubmit() {
            this.$refs.formValidate.validate((valid) => {
                if (valid) {
                    this.pwdUpdate()
                }
            })
        },
        handlePwdCancel() {
            this.$refs.formValidate.resetFields()
        },
        showPasswordClick() {
            this.showPassword = !this.showPassword
            this.handlePwdCancel()
        },
        pwdUpdate() {
            api.pwdUpdate(this.passwordForm).then((res) => {
                if (res.resultCode === 0) {
                    this.$Message.success('修改密码成功')
                    this.handlePwdCancel()
                    this.showPassword = false
                } else {
                    this.$Message.error(res.resultMessage)
                }
            })
        }
    }
}
</script>
<style lang="less" scoped>
.layout-main-content {
    .ivu-divider-horizontal.ivu-divider-with-text-center:before,
    .ivu-divider-horizontal.ivu-divider-with-text-center:after {
        border-top: 1px solid var(--theme-menu-item-selected-bg-color);
    }
    .ivu-divider-inner-text {
        color: var(--theme-menu-item-selected-bg-color);
    }
    .title {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: wrap;
    }
    .head-title {
        font-size: 24px;
        font-weight: 600;
        color: var(--base-font-color);
        line-height: 33px;
    }
    .title .icon {
        width: 8px;
        height: 24px;
        background: var(--theme-menu-item-selected-bg-color);
        margin-right: 12px;
        display: inline-block;
    }
    .content {
        width: 100%;
        height: calc(100% - 43px);
        margin-top: 10px;
        /*background-color: #fff;*/
        padding: 80px;
        overflow-y: scroll;
        .center-content {
            width: 600px;
            margin: 0 auto;
            .form-content {
                padding: 20px;
                img {
                    display: block;
                    width: 85px;
                    height: 85px;
                    border-radius: 50%;
                    float: left;
                }
                .form {
                    width: calc(100% - 150px);
                    margin-left: 60px;
                    float: left;
                    .ivu-input-wrapper {
                        width: 90%;
                    }
                    .btn-wrap {
                        /deep/ .ivu-form-item-content {
                            float: right;
                            margin-right: 30px;
                        }
                    }
                }
                .form-tooltip {
                    margin-left: 8px;
                    cursor: pointer;
                }
            }
        }
    }
    .icon-up {
        display: inline-block;
    }
    .down {
        transform: rotateZ(180deg);
    }
}
.clearfix {
    &:after {
        visibility: hidden;
        display: block;
        font-size: 0;
        content: ' ';
        clear: both;
        height: 0;
    }
}
</style>
